// extracted by mini-css-extract-plugin
export default {"tile":"city_tile_tile__DnVpW","tileImage":"city_tile_tileImage__nTh9g","tileTitle":"city_tile_tileTitle__4+T6t"};